import { render, staticRenderFns } from "./purchase-success.vue?vue&type=template&id=c5f7b0ee&scoped=true&"
import script from "./purchase-success.vue?vue&type=script&lang=js&"
export * from "./purchase-success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f7b0ee",
  null
  
)

export default component.exports